import { EditFeedPage } from "./EditFeedPage";

export default EditFeedPage;